module.exports = __webpack_public_path__ + "static/media/sf_pro-regular.3bd56bb7.woff";